import { render } from "./LinkExpirado.vue?vue&type=template&id=fc6185dc"
import script from "./LinkExpirado.vue?vue&type=script&lang=js"
export * from "./LinkExpirado.vue?vue&type=script&lang=js"
script.render = render

export default script